import React from 'react'

const WelcomeBlockedView = () => {
  return (
    <div className="text-center mt-5">
      <img 
        src="/images/logo_blue.png" 
        alt="VACWAYlockers" 
        height={56}
        className="mb-6"
      />
      <h5 className="mt-5">
        Bienvenido a VACWAYlockers Management
      </h5>
    </div>
  )
}

export default WelcomeBlockedView
